
import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { MedicationRequest } from "../../interfaces/pharmacy";
import { ColumnType, ButtonType } from "../../shared/utils/enums";
import dayjs from "dayjs";
import { Check, X } from "lucide-react";

export const getMedicationRequestsColumns = (
    onApprove: (row: MedicationRequest) => void,
    onReject: (row: MedicationRequest) => void
): TableColumnsItem[] => [
    { key: "medicationName", name: "Medication", type: ColumnType.TEXT, cardTitle: true },
    { key: "dosage", name: "Dosage", type: ColumnType.TEXT },
    { key: "patientName", name: "Patient Name", type: ColumnType.TEXT },
    { 
      key: "requestDate", 
      name: "Date", 
      type: ColumnType.TEXT,
      onRender: (row: MedicationRequest) => dayjs(row.requestDate).format("DD/MM/YYYY HH:mm"),
    },
    { key: "status", name: "Status", type: ColumnType.STATUS },
    {
      key: "actions",
      name: "Actions",
      type: ColumnType.BUTTON,
      buttonsList: [
        {
          type: ButtonType.ICON,
          icon: Check,
          onPress: (e: React.MouseEvent, row: MedicationRequest) => onApprove(row),
          tooltip: "Approve",
          showWhen: (row: MedicationRequest) => row.status === 'Pending',
        },
        {
          type: ButtonType.ICON,
          icon: X,
          onPress: (e: React.MouseEvent, row: MedicationRequest) => onReject(row),
          tooltip: "Reject",
          showWhen: (row: MedicationRequest) => row.status === 'Pending',
        },
      ],
    },
]; 